import React from 'react';
import { useTranslation } from 'react-i18next';

import Rotation from './rotation';

interface RotatableGalleryProps {
  images: { webp?: string; url: string }[];
  imageAlt?: string;
  fullscreen?: boolean;
}

const RotatableGallery = ({ images, imageAlt, fullscreen }: RotatableGalleryProps) => {
  const { t } = useTranslation(['other']);

  return (
    <div
      data-am-image360={fullscreen ? '' : 'contain'}
      data-description={t('dragImageToRotate', { ns: 'other' })}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Rotation>
        {images.map((image) => (
          <picture key={image.url}>
            {image.webp && <source type="image/webp" srcSet={image.webp} />}
            <img key={image.url} src={image.url} alt={imageAlt} />
          </picture>
        ))}
      </Rotation>
    </div>
  );
};

export default RotatableGallery;
